import { Component } from '@opten/compiler/metadata/component';
import { debounce } from '@opten/reactive/debounce';

@Component({ className: 'js-progress' })
export class ProgressComponent {
	private svg: SVGElement;
	private cricleFill: SVGCircleElement;
	private circleState: SVGCircleElement;

	private stroke: number;
	private radius: number;
	private normalizedRadius: number;
	private circumference: number;

	constructor(private element: HTMLElement) {
		this.svg = document.createElementNS(
			'http://www.w3.org/2000/svg',
			'svg'
		) as SVGElement;
		this.cricleFill = document.createElementNS(
			'http://www.w3.org/2000/svg',
			'circle'
		) as SVGCircleElement;
		this.circleState = this.cricleFill.cloneNode(true) as SVGCircleElement;
		this.svg.classList.add('c-progress__svg');
		this.cricleFill.classList.add('c-progress__fill');
		this.circleState.classList.add('c-progress__state');
		this.svg.appendChild(this.cricleFill);
		this.svg.appendChild(this.circleState);

		this.init();

		this.element.appendChild(this.svg);

		// tslint:disable-next-line: no-inner-html

		const observer = new IntersectionObserver(
			([e]) => {
				if (e.intersectionRatio >= 1) {
					this.setProgress(
						parseFloat(this.element.getAttribute('data-progress'))
					);
				} else {
					//this.setProgress(0);
				}
			},
			{
				rootMargin: '0px',
				threshold: [1],
			}
		);
		observer.observe(element);

		window.addEventListener(
			'resize',
			debounce(() => {
				this.init();
			}, 300)
		);
	}

	init() {
		this.stroke = parseInt(this.element.getAttribute('data-stroke'), 0);
		this.radius = this.element.clientWidth / 2;
		this.normalizedRadius = this.radius - this.stroke;
		this.circumference = this.normalizedRadius * 2 * Math.PI;

		this.cricleFill.setAttributeNS(
			null,
			'stroke-dasharray',
			`${this.circumference} ${this.circumference}`
		);
		this.cricleFill.setAttributeNS(null, 'stroke-width', `${this.stroke}`);
		this.cricleFill.setAttributeNS(null, 'r', `${this.normalizedRadius}`);
		this.cricleFill.setAttributeNS(null, 'cx', `${this.radius}`);
		this.cricleFill.setAttributeNS(null, 'cy', `${this.radius}`);
		this.circleState.setAttributeNS(
			null,
			'stroke-dasharray',
			`${this.circumference} ${this.circumference}`
		);
		this.circleState.setAttributeNS(null, 'stroke-width', `${this.stroke}`);
		this.circleState.setAttributeNS(
			null,
			'stroke-dashoffset',
			`${this.circumference}`
		);
		this.circleState.setAttributeNS(null, 'r', `${this.normalizedRadius}`);
		this.circleState.setAttributeNS(null, 'cx', `${this.radius}`);
		this.circleState.setAttributeNS(null, 'cy', `${this.radius}`);
	}

	setProgress(percent) {
		const offset =
			this.circumference - (percent / 100) * this.circumference;
		const circle = this.element.querySelector<SVGCircleElement>(
			'.c-progress__state'
		);
		circle.style.strokeDashoffset = `${offset}px`;
	}
}
